<template>
  <div class="video-player">
    <video
      ref="videoDom"
      crossOrigin="anonymous"
      :src="videoUrl"
    ></video>
  </div>
</template>
<script>
export default {
  name: 'VideoPlayer',
  props: {
    videoUrl: {
      type: String,
      default: ''
    },
    endPlay: {
      type: Number,
      default: 0
    },
    volume: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      playing: false,
      times: 0,
      canPlay: false,
      gainNode: null
    };
  },
  watch: {
    volume() {
      if (this.volume < 0) {
        this.$refs.videoDom.volume = 0;
      } else if (this.volume > 1) {
        this.$refs.videoDom.volume = 1;
        if (this.gainNode) this.gainNode.gain.value = this.volume;
      } else {
        // this.gainNode.gain.value = 1;
        this.$refs.videoDom.volume = this.volume;
      }
    }
  },
  mounted() {
    this.$bus.on('videoPlayer.play', this.videoPlay);
    this.$nextTick(() => {
      this.$refs.videoDom.addEventListener('canplay', this.canPlayFunc);
      this.$refs.videoDom.addEventListener('timeupdate', this.timeupdate);
      this.$refs.videoDom.addEventListener('loadedmetadata', this.loadedmetadata);
      //音频放大效果
      // let audioCtx = new AudioContext();
      // var source = audioCtx.createMediaElementSource(this.$refs.videoDom);
      // var gainNode = audioCtx.createGain();
      // gainNode.gain.value = 1;
      // source.connect(gainNode);
      // gainNode.connect(audioCtx.destination);
      // this.gainNode = gainNode;
      // this.gainNode.gain.value = 1;
      // this.$refs.videoDom.volume = 1;
    });
  },
  beforeDestroy() {
    this.$refs.videoDom.removeEventListener('canplay', this.canPlayFunc);
    this.$refs.videoDom.removeEventListener('timeupdate', this.timeupdate);
    this.$refs.videoDom.removeEventListener('loadedmetadata', this.loadedmetadata);
    this.$refs.videoDom = null;
    this.$bus.off('videoPlayer.play');
  },
  methods: {
    canPlayFunc() {
      this.canPlay = true;
      let from = this.$parent.$options.name || 'videoPlayer';
      //console.log('this.$parent.$options.name', this.$parent.$options.name);
      this.$bus.emit(`${from}.canPlay`, this.$refs.videoDom.duration);
    },
    videoPlay(data) {
      if (typeof data.time === 'number') {
        this.currentTime(data.time);
      }
      if (data.play) {
        this.play();
      } else {
        this.pause();
      }
    },
    play() {
      if (!this.canPlay) return;
      this.$refs.videoDom.play();
      this.playing = true;
    },
    pause() {
      if (!this.canPlay) return;
      this.$refs.videoDom.pause();
      this.playing = false;
    },
    currentTime(time) {
      if (!this.canPlay) return;
      this.$refs.videoDom.currentTime = time;
    },
    timeupdate() {
      if (!this.playing) return;
      let ct = this.$refs.videoDom.currentTime;
      // 这里代替了end事件（视频播放完毕）同时也是裁剪视频的极限判断
      if (ct >= this.endPlay) {
        this.pause();
        this.$refs.videoDom.currentTime = this.endPlay;
        this.$emit('ended');
      }
      this.$emit('timeupdate', ct);
    },
    loadedmetadata(e) {
      this.$emit('loadedmetadata', e);
    }
  }
};
</script>
<style lang="scss" scoped>
.video-player {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #ffffff;

  video {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
